// Function to set a cookie with a specified name, value, and duration
function setCookie(name, value, durationMinutes) {
  var d = new Date();
  d.setTime(d.getTime() + durationMinutes * 60 * 1000); // Convert duration to milliseconds
  var expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// Function to get the value of a cookie by name
function getCookie(name) {
  var cookieName = name + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookie = cookieArray[i];
    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) == 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return null;
}

// Função para excluir um cookie pelo nome
function deleteCookie(name) {
  // Define a data de expiração para uma data passada
  var d = new Date();
  d.setTime(d.getTime() - 1); // Define a data para um milissegundo no passado
  var expires = "expires=" + d.toUTCString();
  document.cookie = name + "=;" + expires + ";path=/";
}

exports.getCodeWasSentCookie = (cpf) => {
  return getCookie("codeWasSent" + cpf);
};

exports.setCodeWasSentCookie = (cpf) => {
  setCookie("codeWasSent" + cpf, cpf, 60);
};

exports.exludeCodeWasSentCookie = (cpf) => {
  deleteCookie("codeWasSent" + cpf);
};

// Is used by New Users
// Esse metodo obtem o numero do cpf de um dispositivo que foi validado via codigo SMS
// é usado para voltar e concluir um cadastro sem precisar validar novamente
exports.getDeviceNumberIsValidated = (cpf) => {
  const currentValue = getCookie("deviceIsValidated");
  return currentValue && currentValue === cpf;
};

exports.setDeviceNumberIsValidated = (value) => {
  setCookie("deviceIsValidated", value, 60);
};

exports.getLatestConfirmedCodeFromCookie = () => {
  return getCookie("confirmedCode");
};

exports.setLatestConfirmedCodeFromCookie = (value) => {
  setCookie("confirmedCode", value, 60);
};

exports.exludeLatestConfirmedCodeFromCookie = () => {
  deleteCookie("confirmedCode");
};
exports.exludeDeviceNumberIsValidated = () => {
  deleteCookie("deviceIsValidated");
};

exports.getCodeForNewUserWasSentCookie = () => {
  return getCookie("codeForNewWasSent");
};

exports.setCodeForNewUserWasSentCookie = (value) => {
  setCookie("codeForNewWasSent", value, 60);
};

exports.exludeCodeForNewUserWasSentCookie = () => {
  deleteCookie("codeForNewWasSent");
};
